import { useInvestmentDetails } from "./hooks";
import Card from "../ui/Card";
import {
  Label,
  Input,
  Select,
  DrawdownAmount,
  RadioGroup,
  RadioOption,
  RadioInput,
} from "./styles";

const InvestmentDetailsCard = ({ props }: any) => {
  const {
    clientName,
    handleClientNameChange,
    product,
    handleProductChange,
    hasDrawdown,
    handleHasDrawdownChange,
    drawdown,
    handleDrawdownChange,
    handleDrawdownBlur,
  } = useInvestmentDetails();
  return (
    <Card title="Investment details" {...props}>
      <Label>Client name</Label>

      <Input
        value={clientName}
        onChange={(e) => handleClientNameChange(e.target.value)}
      />

      <Label>Select a product</Label>

      <Select
        value={product}
        onChange={(e) => handleProductChange(e.target.value)}
      >
        <option value="">Select a product...</option>
        <option value="Synergy ARF">Synergy ARF</option>
        <option value="Synergy Buy Out Bond">Synergy Buy Out Bond</option>
        <option value="Synergy Corporate Bond">Synergy Corporate Bond</option>
        <option value="Synergy Investment Bond">Synergy Investment Bond</option>
        <option value="Synergy Personal Pension">
          Synergy Personal Pension
        </option>
        <option value="Synergy Portfolio Bond">Synergy Portfolio Bond</option>
        <option value="Synergy PRSA">Synergy PRSA</option>
        <option value="Synergy Regular Invest">Synergy Regular Invest</option>
      </Select>

      {product === "Synergy ARF" && (
        <>
          <Label>Drawdown</Label>

          <RadioGroup>
            <RadioOption>
              <RadioInput
                type="radio"
                name="drawdown"
                id="yes"
                checked={hasDrawdown === true}
                onChange={() => handleHasDrawdownChange(true)}
              />
              <Label htmlFor="yes">Yes</Label>
            </RadioOption>

            <RadioOption>
              <RadioInput
                type="radio"
                name="drawdown"
                id="no"
                checked={hasDrawdown === false}
                onChange={() => handleHasDrawdownChange(false)}
              />
              <Label htmlFor="no">No</Label>
            </RadioOption>
          </RadioGroup>

          {hasDrawdown && (
            <>
              <Label>Drawdown amount</Label>

              <DrawdownAmount
                suffix="%"
                maxLength={3}
                defaultEmptyValueToZero={true}
                value={drawdown.toString()}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleDrawdownChange(parseFloat(e.target.value))
                }
                onBlur={(e: React.FocusEvent<HTMLInputElement>) =>
                  handleDrawdownBlur(parseFloat(e.target.value))
                }
              />
            </>
          )}
        </>
      )}
    </Card>
  );
};
export default InvestmentDetailsCard;
